export default __webpack_public_path__ + "static/7-e142f7715ae0dbd813e85b7fba95967a.jpg";